export default "__VITE_ASSET__DNk5MdSy__"